/** Chart display symbol ↔ ClickHouse / ML data symbol. */
export const CHART_TO_DATA_SYMBOL: Record<string, string> = {
  V25_1S: '1HZ25V',
  '1HZ25V': '1HZ25V',
};

export function chartSymbol(): string {
  return localStorage.getItem('aurexis_symbol') || '1HZ25V';
}

export function dataSymbol(chartSym?: string): string {
  const s = chartSym ?? chartSymbol();
  return CHART_TO_DATA_SYMBOL[s] ?? s;
}

/** Tell the Learning panel to refresh drawn shapes from shape-engine. */
export function notifyShapesChanged(kind: 'created' | 'updated' = 'created') {
  try {
    localStorage.setItem('aurexis_shapes_version', String(Date.now()));
  } catch { /* private mode */ }
  window.dispatchEvent(new CustomEvent('aurexis_shapes_changed', { detail: { kind } }));
}
